/*
 *   Container
 */

$class: ".gov-container";

#{$class} {
	@include container();
}
